var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-popup',{attrs:{"value":_vm.value,"headline":`Re-Open Account`,"info":_vm.generateInfo(),"icon":'sidebar_company_big',"actionLabel":"Re-Open"},on:{"input":_vm.closePopup,"onAction":_vm.onAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }